export const AvailabilityFilter = {
    INACTIVE: { id: 0 },
    ACTIVE: { id: 1 },
} as const;

export const ObjectReservationKind = {
    STANDARD: 0,
    ABSTRACT: 1,
    VIRTUAL_ABSTRACT: 2,
    VIRTUAL_STANDARD: 3,
    TEMPLATE: 4,
} as const;

export enum ObjectSuggestionType {
    NONE = "NONE",
    VIRTUAL_FILTER_OBJECT = "VIRTUAL_FILTER_OBJECT",
    VIRTUAL_FILTER_FIELD = "VIRTUAL_FILTER_FIELD",
    RELATED_OBJECT = "RELATED_OBJECT",
    RELATED_FIELD = "RELATED_FIELD",
    LAST_RESERVED = "LAST_RESERVED",
}
